'use client';
import React from 'react';
import s from './ReferredList.module.css';
import { ReactSVG } from 'react-svg';
import { hideDecorativeSvg } from '@/lib/a11y';
import { ReferredListProps } from '@/types/model';
import { formatearMonedaMXN } from '@/lib/helpers';
import { Button } from '@/components';
import { useTranslations } from 'next-intl';
import { Link } from '@/i18n/navigation';

const ReferredList = ({ title, item }: ReferredListProps) => {
  const t = useTranslations('referred');
  return (
    <div className={s.referred}>
      <p className={s.referred__title}>{title}</p>
      <div className={s.referred__list}>
        {item.map((item, i) => {
          return (
            <div key={i}>
              <p>{item.label}</p>
              <div>
                <ReactSVG
                  src="/icons/flecha-boton.svg"
                  className={s.arrow}
                  wrapper="span"
                  beforeInjection={hideDecorativeSvg}
                />
              </div>
              <p>{formatearMonedaMXN(item.money)}</p>
            </div>
          );
        })}
      </div>

      <Link className={s.referred__link} href="/aviso-programa-de-referidos">
        {t('terms')}
      </Link>
      <div className={s.referred__button}>
        <Button
          label={t('referButton')}
          onClick={() =>
            window.open('https://share.hsforms.com/1ciGNvLKQQq2IcQmpPVnetwq35cw', '_blank')
          }
        />
      </div>
    </div>
  );
};

export default ReferredList;
